import { FC } from 'react';
import { Space, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

const { Text } = Typography;

const Loading: FC = () => {
    const { t } = useTranslation('shared');

    return (
        <div className="loader">
            <Space direction="vertical" align="center" size={8}>
                <object width={84} height={84} type="image/svg+xml" data="/images/loader.svg">
                    <img src="/images/loader.svg" alt="loader" />
                </object>
                <Text>
                    { t('LOADING') }
                </Text>
            </Space>
        </div>
    );
};

export { Loading };
